var map = {
	"./1.webp": 3358,
	"./2.webp": 511,
	"./3.webp": 8972,
	"./4.webp": 8189,
	"./5.webp": 2789,
	"./6.webp": 8947,
	"./7.webp": 5104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8468;